import React from "react"

import { TResolvedTextMedia } from "@/lib/kontent/components/getTextMedia"

import { ImageAndText } from "./ImageAndText"

type TImageAndTextResolverProps = {
  resolvedData: TResolvedTextMedia
  isInArticle?: boolean
}

const ImageAndTextResolver = ({
  resolvedData,
  isInArticle = false,
}: TImageAndTextResolverProps) => {
  const kontentData = {
    title: resolvedData.title,
    body: resolvedData.text,
    reverse: resolvedData.imagePosition === "Right",
    icon: resolvedData.icon,
    tag: resolvedData.tag,
    image: {
      src: resolvedData.image?.url,
      alt: resolvedData.image?.description,
      variant: "default",
      width: resolvedData.image?.width,
      height: resolvedData.image?.height,
    },
    isInArticle: isInArticle,
  }

  return <ImageAndText {...kontentData} />
}

export { ImageAndTextResolver, type TImageAndTextResolverProps }
